import type { SocialIdentity } from '@blockbattle/shared';
import { useEffect, useState, type CSSProperties } from 'react';
import { avatarFrameGradient } from '../avatar-frame.js';
import './vip-badge.css';

export function Avatar({
  name,
  url,
  size = 46,
  frameColor,
  frameGradient,
  frameName,
  social,
  vipUntil,
}: {
  name: string;
  url?: string | null;
  size?: number;
  frameColor?: string | null;
  frameGradient?: string | null;
  frameName?: string | null;
  social?: SocialIdentity | null | undefined;
  vipUntil?: string | null | undefined;
}) {
  const [failed, setFailed] = useState(false);
  useEffect(() => setFailed(false), [url]);
  const initials =
    name
      .trim()
      .split(/\s+/)
      .filter(Boolean)
      .map((part) => part[0])
      .join('')
      .slice(0, 2)
      .toUpperCase() || '?';
  const resolvedFrameColor = frameColor ?? social?.frame?.color ?? null;
  const resolvedFrameGradient =
    frameGradient ??
    social?.frame?.gradient ??
    (resolvedFrameColor ? avatarFrameGradient(resolvedFrameColor) : null);
  const resolvedFrameName = frameName ?? social?.frame?.name ?? null;
  const hasFrame = Boolean(resolvedFrameColor || resolvedFrameGradient);
  const expiry = vipUntil ?? social?.vipUntil;
  const vip = Boolean(expiry && Date.parse(expiry) > Date.now());
  return (
    <span
      className={`avatar ${hasFrame ? 'has-cosmetic-frame has-gradient-frame' : ''}${vip ? ' has-vip' : ''}`}
      title={resolvedFrameName ? `Рамка: ${resolvedFrameName}` : undefined}
      data-cosmetic-frame={hasFrame ? resolvedFrameName || 'active' : undefined}
      style={
        {
          width: size,
          height: size,
          '--avatar-frame': resolvedFrameColor ?? undefined,
          '--avatar-frame-gradient': resolvedFrameGradient ?? undefined,
        } as CSSProperties
      }
    >
      {hasFrame ? (
        <span className="avatar-frame-petals" aria-hidden="true">
          <i />
          <i />
          <i />
        </span>
      ) : null}
      {url && !failed ? (
        <img
          src={url}
          alt={`Аватар ${name}`}
          loading="lazy"
          decoding="async"
          referrerPolicy="no-referrer"
          onError={() => setFailed(true)}
        />
      ) : (
        <span className="avatar-initials">{initials}</span>
      )}
      {vip ? (
        <span
          className="avatar-vip"
          title="VIP — активный VIP пропуск"
          aria-label="VIP, активный VIP пропуск"
        >
          VIP
        </span>
      ) : null}
    </span>
  );
}
